<template>
  <div>
    <tooltip label="View" type="default" placement="left">
      <a class="button button-table is-small" @click="view()">
        <i class="fa fa-eye"></i>
      </a>
    </tooltip>
  </div>
</template>

<script>
  import Tooltip from 'vue-bulma-tooltip'
  import Message from '../../utils/message'
  import Logs from './logs'
  export default {
    data () {
      return {
        inProgress: false
      }
    },
    props: {
      data: {
        type: Object,
        required: true
      }
    },
    components: {
      Tooltip
    },
    methods: {
      view () {
        let propsData = {
          context: this,
          log_id: parseInt(this.data.id),
          title: 'Log',
          callback: 'logCallback'
        }
        Logs.openLog(propsData)
      },
      logCallback (result) {
        let propsData = null
        if (result.ok) {
          propsData = {
            title: 'Success',
            message: result.message,
            type: 'success',
            direction: 'down',
            duration: 4500,
            showCloseButton: true
          }
          Message.openMessage(propsData)
          this.$parent.loadData()
        }
      }
    }
  }
</script>

<style lang="scss">
  .button-table {
    padding-top: 6px;
  }
</style>



// WEBPACK FOOTER //
// LogTableButtons.vue?6f3c8fb1